@use '@/styles/tokens' as *;

.times {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--space-4);
}

.field {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.label {
  font-size: 14px;
  color: var(--text-secondary);
}
